export const steps = [
    'employee', 'activities', 'grading', 'partners', 'validation'
];
